import $ from 'jquery'
import Cookies from 'js-cookie'

const ctaWrapper = document.querySelector('.home-cta__wrapper')

const setCtaSizes = () => {
  const ctaInner = document.querySelector('.home-cta__inner')

  if (!ctaInner) {
    return
  }

  const rect = ctaInner.getBoundingClientRect()
  ctaWrapper.style.cssText = `--cta-height: ${rect.height + 60}px`
}

window.addEventListener('load', setCtaSizes)
window.addEventListener('resize', setCtaSizes)

$('.home-cta__toggle').on('click', function () {
  $('.home-cta').toggleClass('home-cta--active')

  const active = $('.home-cta').hasClass('home-cta--active')
  const cookieVal = active ? 1 : 0
  Cookies.set('speakerActive', cookieVal)

  setTimeout(() => {
    setCtaSizes()
  }, 250)
})
